export default __webpack_public_path__ + "static/media/PersImg25.312d0fad.jpg";